

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import dataModule from '@/store/data'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';


let servers = {
  "www.uvaempleo.com" : "https://backoffice.uvaempleo.com",
  "uvaempleo.com" : "https://backoffice.uvaempleo.com",
  "uvaempleo.dev.doubledot.es" : "https://sandbox-uva.dotia.es/",
  "localhost" : "https://sandbox-uva.dotia.es/"
}


export const store = new Vuex.Store({
  state :{
    language: localStorage.getItem('language') || 'es',
    server : servers[location.hostname]
  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    }
  },
  modules :{
    dataModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js